import React from 'react';
import type { ContentItemWithAuthorModel } from '@domain/models';
import { RowLoader } from '@presentation/components/Loader';
import InfiniteScroll from 'react-infinite-scroller';
import { Grid } from '@mui/material';
import { ArtworkCard } from '@presentation/components/ArtworkCard';

export type ArtworkInfiniteScrollListProps = {
	data: ContentItemWithAuthorModel[];
	hasMore: boolean;
	loadMore: () => void;
};

export const ArtworkInfiniteScrollList = (props: ArtworkInfiniteScrollListProps) => {
	const { data, hasMore, loadMore } = props;

	if (!data.length) {
		return <RowLoader />;
	}

	return (
		<InfiniteScroll pageStart={0} loadMore={loadMore} hasMore={hasMore} loader={<RowLoader />}>
			<Grid container spacing={2}>
				{data?.length > 0 &&
					data.map((item) => (
						<Grid item xs={12} sm={4} md={3} lg={2} key={item.id}>
							<ArtworkCard
								id={item.id}
								imageSrc={item.imageSrc}
								imageName={item.name}
								creator={item.author}
								onAuthorClick={(event) => {
									event.stopPropagation();

									if (item.author?.profileLink) {
										window.location.href = `/${item.author?.profileLink}`;
									}
								}}
							/>
						</Grid>
					))}
			</Grid>
		</InfiniteScroll>
	);
};
